export default __webpack_public_path__ + "static/media/file-active.44db66ba.svg";